// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-65e59602] .recordNeutralStyle{background-color:#babfb8!important;color:#000!important}", ""]);
// Exports
module.exports = exports;
